import { UnitOfMeasure } from '../types/dtos'

export function marshallUnits(units: UnitOfMeasure[]) {
	const nameMap = new Map()
	const names = []
	const typeMap = new Map()
	const types = []
	const pushRef = (o, map, list) => {
		let i = map.get(o.Id)
		if (i == null) {
			map.set(o.Id, i = list.length)
			list.push(o)
		}
		return i
	}
	return {
		units: units.map(unit =>
			[unit.Id, pushRef(unit.Name, nameMap, names), pushRef(unit.Type, typeMap, types)]
		),
		names,
		types
	}
}

export function unmarshallUnits({ units, names, types }) {
	return units.map(([Id, nameIdx, typeIdx]) => ({
		Id,
		Name: names[nameIdx],
		Type: types[typeIdx]
	}))
}